import { gql } from '@apollo/client';

export const EDIT_SURROUNDING_INFORMATION_MUTATION = gql`
  fragment CommonSurroundingInformationEdit on SurroundingInformation {
    id
    title
    bodyText
    bannerImage {
      id
      url
      formats
    }
    locale
    locationLat
    locationLon
    locationName
    website
    phoneNr
    shortDescription
    externalBannerImage
    hidden
    fusionarId
    disabledSynchronisationFields
    openingTimes
  }
  mutation EditSurroundingInformation($id: ID!, $data: editSurroundingInformationInput!) {
    updateSurroundingInformation(input: { where: { id: $id }, data: $data }) {
      surroundingInformation {
        ...CommonSurroundingInformationEdit
      }
    }
  }
`;
